import React from "react";
import ReactDropdown from "react-dropdown";
import "react-dropdown/style.css";
import "./DropDown.css";

const DropDown = ({ onRegionChange }) => {
  
  const regions = ["Africa", "Americas", "Asia", "Europe", "Oceania"];

  return (
    <div className="dropdown__wrapper">
      <ReactDropdown
        options={regions}
        onChange={(e) => onRegionChange(e.value.toLowerCase())}
        placeholder="Filter by Region"
      />
    </div>
  );
};

export default DropDown;
